import { isEmptySlateDocument } from "../../../core/constants";
import { TextDetails } from "../../../resources/modelTypes";
import { SectionComponentProps } from "../../types";
import { ThemedRichText } from "./ThemedRichText";
import { SmallHeadline } from "@minted/fancyclothes";
import React, { memo } from "react";

const DisplayTextSection = ({ section }: SectionComponentProps) => {
  const details = section.sectionDetails as TextDetails;

  return (
    <>
      {Boolean(details.title) && <SmallHeadline>{details.title}</SmallHeadline>}
      {!isEmptySlateDocument(details.content) && (
        <ThemedRichText content={details.content} />
      )}
    </>
  );
};

const MemoizedDisplayImageAndText = memo(DisplayTextSection);

export { MemoizedDisplayImageAndText as DisplayTextSection };
